const bgColor = "#000000";//背景
const upColor = "#F9293E";//涨颜色
const downColor = "#00aa3b";//跌颜色

// ma  颜色
const ma5Color = "#39afe6";
const ma10Color = "#da6ee8";
const ma20Color = "#ffab42";
const ma30Color = "#00940b";

/**
 * 15:20 时:分 格式时间增加num分钟
 * @param {Object} time 起始时间
 * @param {Object} num
 */
function addTimeStr(time, num) {
    var hour = time.split(':')[0];
    var mins = Number(time.split(':')[1]);
    var mins_un = parseInt((mins + num) / 60);
    var hour_un = parseInt((Number(hour) + mins_un) / 24);
    if (mins_un > 0) {
        if (hour_un > 0) {
            const tmpVal = ((Number(hour) + mins_un) % 24) + "";
            hour = tmpVal.length > 1 ? tmpVal : '0' + tmpVal;//判断是否是一位
        } else {
            const tmpVal = Number(hour) + mins_un + "";
            hour = tmpVal.length > 1 ? tmpVal : '0' + tmpVal;
        }
        const tmpMinsVal = ((mins + num) % 60) + "";
        mins = tmpMinsVal.length > 1 ? tmpMinsVal : 0 + tmpMinsVal;//分钟数为 取余60的数
    } else {
        const tmpMinsVal = mins + num + "";
        mins = tmpMinsVal.length > 1 ? tmpMinsVal : '0' + tmpMinsVal;//不大于整除60
    }
    return (hour === '11' && mins === '31' ? "13:00" : hour + ":" + mins);
}

//获取增加指定分钟数的 数组  如 09:30增加2分钟  结果为 ['09:31','09:32']
function getNextTime(startTime, endTIme, offset, resultArr) {
    const result = addTimeStr(startTime, offset);
    resultArr.push(result);
    const t_1 = new Date().setHours(+result.split(':')[0], +result.split(':')[1]);
    const t_2 = new Date().setHours(+endTIme.split(':')[0], endTIme.split(':')[1]);
    if (t_1 >= t_2) {
        return resultArr;
    } else {
        return getNextTime(result, endTIme, offset, resultArr);
    }
}


/**
 * 不同类型的股票的交易时间会不同
 * @param {Object} type   hs=沪深  us=美股  hk=港股
 */
const getMinutesStr = function (time) {
    if (time.toString().length === 1) {
        return '0' + time.toString();
    }
    return time;
};
const time_arr = function (time) {
    return (new Date(time).getHours() + ':' + getMinutesStr(new Date(time).getMinutes()));
    // if (type.indexOf('us') !== -1) {//生成美股时间段
    //     const timeArr = [];
    //     timeArr.push('09:30')
    //     return getNextTime('09:30', '16:00', 1, timeArr);
    // }
    // if (type.indexOf('hs') !== -1) {//生成沪深时间段
    //     const timeArr = [];
    //     timeArr.push('09:30');
    //     timeArr.concat(getNextTime('09:30', '11:29', 1, timeArr));
    //     timeArr.push('13:00');
    //     timeArr.concat(getNextTime('13:00', '15:00', 1, timeArr));
    //     return timeArr;
    // }
    // if (type.indexOf('hk') !== -1) {//生成港股时间段
    //     const timeArr = [];
    //     timeArr.push('09:30');
    //     timeArr.concat(getNextTime('09:30', '11:59', 1, timeArr));
    //     timeArr.push('13:00');
    //     timeArr.concat(getNextTime('13:00', '16:00', 1, timeArr));
    //     return timeArr;
    // }
};
var get_m_data = function (m_data) {
    const priceArr = [];
    const avgPrice = [];
    const vol = [];
    let times = [];
    m_data.items[0].map(function (v) {
        priceArr.push(v.price);
        avgPrice.push(v.avgPrice);
        vol.push(v.volumn);
        times.push(time_arr(v.time));
    });
    times = times.concat(getNextTime(times[times.length - 1], '15:00', 1, []));
    return {
        priceArr: priceArr,
        avgPrice: avgPrice,
        vol: vol,
        times: times
    }
};

// 获取分时最大值和最小值
// type true: 最大和最小与做手机啊
const minValue = function (value, detail) {
    const a = Math.abs(detail.low - +detail.preClose);
    const b = Math.abs(detail.high - +detail.preClose);
    return Math.max(+detail.limitDownValue, (+detail.preClose - Math.max(a, b)) * 0.995).toFixed(3);
}
const maxValue = function (value, detail) {
    const a = Math.abs(detail.low - +detail.preClose);
    const b = Math.abs(detail.high - +detail.preClose);
    return Math.min(+detail.limitUpValue, (+detail.preClose + Math.max(a, b)) * 1.005).toFixed(3);
}

//==========================================分时表 option

/**
 * 生成分时option
 * @param {Object} m_data 分时数据
 * @param {Object} detail 股票详情
 */
function initMOption(m_data, detail) {
    const preClose = detail.preClose;
    const m_datas = get_m_data(m_data);
    const min_ = minValue(m_datas.priceArr, detail);
    const max_ = maxValue(m_datas.priceArr, detail);
    return {
        tooltip: { //弹框指示器
            trigger: 'axis',
            axisPointer: {
                type: 'cross'
            },
            formatter: function (params) {
                let i = params[0].dataIndex;
                if (i > m_datas.priceArr.length - 1) {
                    return '';
                }
                let color;
                if (+m_datas.priceArr[i] > +preClose) {
                    color = 'style="color:#FF5046"';
                } else {
                    color = 'style="color:#00C51C"';
                }
                var html = '<div class="commColor" style="width:100px;"><div>当前价 <span  ' + color + ' >' + m_datas.priceArr[i] + '</span></div>';
                html += '<div>均价 <span  ' + color + ' >' + m_datas.avgPrice[i] + '</span></div>';
                html += '<div>涨幅 <span  ' + color + ' >' + ratioCalculate(+m_datas.priceArr[i], +preClose) + '%</span></div>';
                html += '<div>成交量 <span  ' + color + ' >' + m_datas.vol[i] + '</span></div></div>';
                return html;
            }
        },
        legend: { //图例控件,点击图例控制哪些系列不显示
            icon: 'rect',
            type: 'scroll',
            itemWidth: 14,
            itemHeight: 2,
            left: 0,
            top: '-1%',
            textStyle: {
                fontSize: 12,
                color: '#999999'
            }
        },
        color: [ma5Color, ma10Color],
        grid: [
            {
                id: 'gd1',
                left: '1%',
                right: '1%',
                height: '67.5%', //主K线的高度,
                top: '2%'
            },
            {
                id: 'gd2',
                left: '1%',
                right: '1%',
                height: '67.5%', //主K线的高度,
                top: '2%'
            }, {
                id: 'gd3',
                left: '1%',
                right: '1%',
                top: '75%',
                height: '19%' //交易量图的高度
            }
        ],
        xAxis: [ //==== x轴
            { //主图a
                gridIndex: 0,
                data: m_datas.times,
                axisLabel: { //label文字设置
                    color: '#9b9da9',
                    fontSize: 8
                },
                splitLine: {
                    show: false,
                }
            },
            { //主图b
                show: false,
                gridIndex: 1,
                data: m_datas.times,
                axisLabel: { //label文字设置
                    show: false
                },
                splitLine: {
                    show: false,
                }
            }, { //交易量图
                splitNumber: 2,
                type: 'category',
                gridIndex: 2,
                data: m_datas.times,
                axisLabel: { //label文字设置
                    color: '#9b9da9',
                    fontSize: 8
                },
            }
        ],
        yAxis: [ //y轴
            { // 左边
                gridIndex: 0,
                scale: true,
                splitNumber: 10,
                min: min_,
                max: max_,
                axisLabel: { //label文字设置
                    inside: true, //label文字朝内对齐
                    fontSize: 10,
                    color: function (val) {
                        if (+val === +preClose) {
                            return '#aaa'
                        }
                        return +val > +preClose ? upColor : downColor;
                    }
                }, z: 4, splitLine: { //分割线设置
                    lineStyle: {
                        color: '#0b0b0b'
                    }
                },
            }, { // 右边
                scale: true, gridIndex: 1, splitNumber: 0.1,
                position: 'right', z: 4,
                min: min_,
                max: max_,
                axisLabel: { //label文字设置
                    fontSize: 10,
                    color: function (val) {
                        if (+val === +preClose) {
                            return '#aaa'
                        }
                        return +val > +preClose ? upColor : downColor;
                    },
                    inside: true, //label文字朝内对齐
                    formatter: function (val) {
                        var resul = ratioCalculate(+val, +preClose);
                        return Number(resul).toFixed(2) + ' %'
                    }
                },
                splitLine: { //分割线设置
                    show: true,
                    lineStyle: {
                        color: '#181a23'
                    }
                },
                axisPointer: {
                    show: true,
                    label: {
                        formatter: function (params) { //计算右边Y轴对应的当前价的涨幅比例
                            return ratioCalculate(+params.value, +preClose) + '%';
                        }
                    }
                }
            }
            , { //交易图
                gridIndex: 2, z: 4,
                splitNumber: 3,
                axisLine: {
                    onZero: false
                },
                axisTick: {
                    show: false
                },
                splitLine: {
                    show: false
                },
                axisLabel: { //label文字设置
                    color: '#c7c7c7',
                    inside: true, //label文字朝内对齐
                    fontSize: 8
                },
            }
        ],
        dataZoom: [],
        //animation:false,//禁止动画效果
        backgroundColor: bgColor,
        blendMode: 'source-over',
        series: [
            { // 现价
                type: 'line',
                data: m_datas.priceArr,
                smooth: true,
                showSymbol: false,
                symbol: "circle",
                sampling: 'average',
                z: 5,
                hoverAnimation: false,
                connectNulls: true,
                itemStyle: {
                    opacity: 0,
                    color: '#ffffff',
                },
                lineStyle: {
                    normal: {
                        opacity: 1,
                        color: '#ffffff',
                        width: 1
                    }
                },
            }, { // 现价
                type: 'line',
                data: m_datas.avgPrice,
                smooth: true,
                symbol: "circle",
                sampling: 'average',
                showSymbol: false,
                connectNulls: true,
                z: 5,
                hoverAnimation: false,
                itemStyle: {
                    opacity: 0,
                    color: '#b4e81b',
                },
                lineStyle: { // 标线的样式
                    normal: {
                        opacity: 1,
                        color: '#b4e81b',
                        width: 1
                    }
                }
            }, {
                type: 'line',
                data: m_datas.priceArr,
                smooth: true,
                symbol: "circle",
                showSymbol: false,
                gridIndex: 1,
                xAxisIndex: 1,
                yAxisIndex: 1,
                hoverAnimation: false,
                itemStyle: {
                    opacity: 0
                },
                lineStyle: { //标线的样式
                    normal: {
                        width: 0
                    }
                }
            }, {
                type: 'line',
                z: 5,
                data: (function () {
                    const tmp = [];
                    Array(Math.max(m_data.items[0].length, 241)).fill(0).map(v => {
                        tmp.push(+preClose);
                    });
                    return tmp;
                })(),
                symbol: "circle",
                showSymbol: false,
                hoverAnimation: false,
                itemStyle: {
                    opacity: 0,
                    color: '#FF5046',
                },
                lineStyle: { //昨日收盘的样式
                    normal: {
                        type: "dashed",
                        opacity: 1,
                        color: '#FF5046',
                        width: 1
                    }
                }
            },
            {
                type: 'bar',
                gridIndex: 2,
                xAxisIndex: 2,
                yAxisIndex: 2,
                data: m_datas.vol,
                barWidth: '1px',
                itemStyle: {
                    normal: {
                        color: function (params) {
                            var colorList;
                            if (m_datas.priceArr[params.dataIndex] > m_datas.priceArr[params.dataIndex - 1]) {
                                colorList = upColor;
                            } else {
                                colorList = downColor;
                            }
                            return colorList;
                        },
                    }
                }
            }
        ]
    };
}


/**
 * 计算价格涨跌幅百分比
 * @param {Object} price 当前价
 * @param {Object} yclose 昨收价
 */
function ratioCalculate(price, yclose) {
    return ((price - yclose) / yclose * 100).toFixed(3);
}

let maxvolumn = 0;

//数组处理
function splitData(rawData, kType, todayDate) {
    const datas = [];
    const times = [];
    const vols = [];
    const ismonth = kType === 'month';
    //数据模型 time0 open1 close2 min3 max4 vol5 tag6 macd7 dif8 dea9
    //['2015-10-19',18.56,18.25,18.19,18.56,55.00,0,-0.00,0.08,0.09]
    rawData.map(v => {
        datas.push([v.open, v.close, v.low, v.high]);
        times.push(new Date(v.time).format(ismonth ? 'yyyy-MM' : 'yyyy-MM-dd'));
        vols.push(+v.volumn);
    });
    maxvolumn = Math.max.apply(null, vols);
    return {datas, times, vols};
}


//================================MA计算公式
function calculateMA(dayCount, data) {
    const result = [];
    for (let i = 0, len = data.times.length; i < len; i++) {
        if (i < dayCount) {
            result.push('-');
            continue;
        }
        let sum = 0;
        for (let j = 0; j < dayCount; j++) {
            sum += +data.datas[i - j][1];
        }
        result.push((sum / dayCount).toFixed(2));
    }
    return result;
}


//=================================================MADC计算公式

let calcEMA, calcDIF, calcDEA, calcMACD;

/*
 * 计算EMA指数平滑移动平均线，用于MACD
 * @param {number} n 时间窗口
 * @param {array} data 输入数据
 * @param {string} field 计算字段配置
 */
calcEMA = function (n, data, field) {
    let i, l, ema, a;
    a = 2 / (n + 1);
    if (field) {
        //二维数组
        ema = [data[0][field]];
        for (i = 1, l = data.length; i < l; i++) {
            ema.push((a * data[i][field] + (1 - a) * ema[i - 1]).toFixed(2));
        }
    } else {
        //普通一维数组
        ema = [data[0]];
        for (i = 1, l = data.length; i < l; i++) {
            ema.push((a * data[i] + (1 - a) * ema[i - 1]).toFixed(3));
        }
    }
    return ema;
};

/*
 * 计算DIF快线，用于MACD
 * @param {number} short 快速EMA时间窗口
 * @param {number} long 慢速EMA时间窗口
 * @param {array} data 输入数据
 * @param {string} field 计算字段配置
 */
calcDIF = function (short, long, data, field) {
    let i, l, dif, emaShort, emaLong;
    dif = [];
    emaShort = calcEMA(short, data, field);
    emaLong = calcEMA(long, data, field);
    for (i = 0, l = data.length; i < l; i++) {
        dif.push((emaShort[i] - emaLong[i]).toFixed(3));
    }
    return dif;
};

/*
 * 计算DEA慢线，用于MACD
 * @param {number} mid 对dif的时间窗口
 * @param {array} dif 输入数据
 */
calcDEA = function (mid, dif) {
    return calcEMA(mid, dif);
};

/*
 * 计算MACD
 * @param {number} short 快速EMA时间窗口
 * @param {number} long 慢速EMA时间窗口
 * @param {number} mid dea时间窗口
 * @param {array} data 输入数据
 * @param {string} field 计算字段配置
 */
calcMACD = function (short, long, mid, data, field) {
    let i, l, dif, dea, macd, result;
    result = {};
    macd = [];
    dif = calcDIF(short, long, data, field);
    dea = calcDEA(mid, dif);
    for (i = 0, l = data.length; i < l; i++) {
        macd.push(((dif[i] - dea[i]) * 2).toFixed(3));
    }
    result.dif = dif;
    result.dea = dea;
    result.macd = macd;
    return result;
};


//=================================================MADC计算公式 end


function initKOption(cdata, kType, todayDate) {
    let data = splitData(cdata, kType, todayDate);
    let macd = calcMACD(12, 26, 9, data.datas, 1);
    return {
        tooltip: { //弹框指示器
            trigger: 'axis',
            axisPointer: {
                type: 'cross'
            },
            formatter: function (params) {
                if(params.length === 5) {
                    return `开盘：${params[0].value[1]}<BR>`
                    + `收盘：${params[0].value[2]}<BR>`
                    + `最低：${params[0].value[3]}<BR>`
                    + `最高：${params[0].value[4]}<BR>`
                    + `MA5：${params[1].value}<BR>`
                    + `MA10：${params[2].value}<BR>`
                    + `MA20：${params[3].value}<BR>`
                    + `MA30：${params[4].value}<BR>`;
                }
                if(params.length === 1) {
                    return `成交量：${params[0].value}<BR>`;
                }
                if(params.length === 3) {
                    return `MACD：${params[0].value} `
                        + `DIF：${params[1].value} `
                        + `DEA：${params[2].value}`;
                }
            }
        },
        legend: { //图例控件,点击图例控制哪些系列不显示
            icon: 'rect',
            type: 'scroll',
            itemWidth: 14,
            itemHeight: 2,
            left: 0,
            top: '-1%',
            animation: true,
            textStyle: {
                fontSize: 12,
                color: '#0e99e2'
            },
            pageIconColor: '#0e99e2'
        },
        axisPointer: {
            show: true
        },
        color: [ma5Color, ma10Color, ma20Color, ma30Color],
        grid: [{
            id: 'gd1',
            left: '0%',
            right: '1%',
            height: '55%', //主K线的高度,
            top: '5%'
        }, {
            left: '0%',
            right: '1%',
            top: '65%',
            height: '15%' //交易量图的高度
        }, {
            left: '0%',
            right: '1%',
            top: '82%', //MACD 指标
            height: '10%'
        }],
        xAxis: [ //==== x轴
            { //主图
                type: 'category',
                data: data.times,
                scale: true,
                boundaryGap: false,
                axisLine: {
                    onZero: false
                },
                axisLabel: { //label文字设置
                    color: '#9b9da9',
                    fontSize: 8
                },
                splitLine: {
                    show: false,
                    lineStyle: {
                        color: '#3a3a3e'
                    }
                },
                splitNumber: 100,
                min: 'dataMin',
                max: 'dataMax'
            }, { //交易量图
                type: 'category',
                gridIndex: 1,
                data: data.times,
                axisLabel: { //label文字设置
                    show: false
                },
            }, { //幅图
                type: 'category',
                gridIndex: 2,
                data: data.times,
                axisLine: {
                    onZero: false
                },
                axisLabel: { //label文字设置
                    color: '#9b9da9',
                    fontSize: 8
                },
                splitLine: {
                    show: false,
                    lineStyle: {
                        color: '#3a3a3e'
                    }
                },
                splitNumber: 100,
                min: 'dataMin',
                max: 'dataMax'
            }
        ],
        yAxis: [ //y轴
            { //==主图
                scale: true,
                z: 4,
                axisLabel: { //label文字设置
                    color: '#c7c7c7',
                    inside: true, //label文字朝内对齐
                },
                splitLine: { //分割线设置
                    show: false,
                    lineStyle: {
                        color: '#181a23'
                    }
                },
            }, { //交易图
                gridIndex: 1, splitNumber: 1, z: 4,
                max: maxvolumn,
                axisLine: {
                    onZero: false
                },
                axisTick: {
                    show: false
                },
                splitLine: {
                    show: false
                },
                axisLabel: { //label文字设置
                    color: '#c7c7c7',
                    inside: true, //label文字朝内对齐
                    fontSize: 8
                },
            }, { //幅图
                z: 4, gridIndex: 2, splitNumber: 4,
                axisLine: {
                    onZero: false
                },
                axisTick: {
                    show: false
                },
                splitLine: {
                    show: false
                },
                axisLabel: { //label文字设置
                    color: '#c7c7c7',
                    inside: true, //label文字朝内对齐
                    fontSize: 8
                },
            }
        ],
        dataZoom: [{
            type: 'inside',
            xAxisIndex: [0, 1, 2], //控件联动
            start: 100,
            end: 20,
            minSpan: 20
        }],
        animation: false, //禁止动画效果
        backgroundColor: '#000',
        blendMode: 'source-over',
        series: [{
            id: 1,
            name: 'K线',
            type: 'candlestick',
            data: data.datas,
            barWidth: '55%',
            large: true,
            largeThreshold: 150,
            progressiveThreshold:10,
            itemStyle: {
                normal: {
                    color: upColor, //fd2e2e  ff4242
                    color0: downColor,
                    borderColor: upColor,
                    borderColor0: downColor,
                }
            },

        }, {
            id: 2,
            name: 'MA5',
            type: 'line',
            data: calculateMA(5, data),
            smooth: true,
            symbol: "none", //隐藏选中时有小圆点
            lineStyle: {
                normal: {
                    opacity: 0.8,
                    color: '#39afe6',
                    width: 1
                }
            },
        },
            {
                id: 3,
                name: 'MA10',
                type: 'line',
                data: calculateMA(10, data),
                smooth: true,
                symbol: "none",
                lineStyle: { //标线的样式
                    normal: {
                        opacity: 0.8,
                        color: '#da6ee8',
                        width: 1
                    }
                }
            },
            {
                id: 4,
                name: 'MA20',
                type: 'line',
                data: calculateMA(20, data),
                smooth: true,
                symbol: "none",
                lineStyle: {
                    opacity: 0.8,
                    width: 1,
                    color: ma20Color
                }
            },
            {
                id: 5,
                name: 'MA30',
                type: 'line',
                data: calculateMA(30, data),
                smooth: true,
                symbol: "none",
                lineStyle: {
                    normal: {
                        opacity: 0.8,
                        width: 1,
                        color: ma30Color
                    }
                }
            }, {
                id: 6,
                name: '成交量',
                type: 'bar',
                xAxisIndex: 1,
                yAxisIndex: 1,
                data: data.vols,
                barWidth: '60%',
                itemStyle: {
                    normal: {
                        color: function (params) {
                            var colorList;
                            if (data.datas[params.dataIndex][1] > data.datas[params.dataIndex][0]) {
                                colorList = upColor;
                            } else {
                                colorList = downColor;
                            }
                            return colorList;
                        },
                    }
                }
            }, {
                id: 7,
                name: 'MACD',
                type: 'bar',
                xAxisIndex: 2,
                yAxisIndex: 2,
                data: macd.macd,
                barWidth: '2px',
                itemStyle: {
                    normal: {
                        color: function (params) {
                            var colorList;
                            if (params.data >= 0) {
                                colorList = upColor;
                            } else {
                                colorList = downColor;
                            }
                            return colorList;
                        },
                    }
                }
            }, {
                id: 8,
                name: 'DIF',
                type: 'line',
                symbol: "none",
                xAxisIndex: 2,
                yAxisIndex: 2,
                data: macd.dif,
                lineStyle: {
                    normal: {
                        color: '#da6ee8',
                        width: 1
                    }
                }
            }, {
                id: 9,
                name: 'DEA',
                type: 'line',
                symbol: "none",
                xAxisIndex: 2,
                yAxisIndex: 2,
                data: macd.dea,
                lineStyle: {
                    normal: {
                        opacity: 0.8,
                        color: '#39afe6',
                        width: 1
                    }
                }
            }
        ]
    };


}

export default {
    initKOption, initMOption
}

